




























import Vue from 'vue'
import { faStar, faStarHalfAlt } from '@fortawesome/free-solid-svg-icons'
import { faStar as farStar } from '@fortawesome/free-regular-svg-icons/faStar'
import CGoogleRatingMixin from '~/components/shared/configurable/mixin/CGoogleRatingMixin.vue'

export default Vue.extend({
  mixins: [CGoogleRatingMixin],
  props: {
    rating: {
      type: String,
      required: true
    }
  },
  data: () => ({
    icons: {
      star: faStar,
      starHalfAlt: faStarHalfAlt,
      rStar: farStar
    }
  })
})
